<template>
    <div
        ref="modal"
        class="modal center fade"
        :class="[classComputedModal]"
        role="dialog"
        tabindex="-1"
    >
        <div
            class="modal-dialog"
            :class="{
                'modal-sm': size === 'sm',
                'modal-lg': size === 'lg',
            }"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        class="close"
                        type="button"
                        aria-label="Close"
                        data-dismiss="modal"
                        :disabled="isLoading"
                        @click="close"
                    >
                        <span aria-hidden="true">
                            <i class="fa fa-times"></i>
                        </span>
                    </button>

                    <h4 class="modal-title">
                        <slot name="header" />
                    </h4>
                </div>

                <slot name="default" />

                <div
                    v-if="$slots.body"
                    class="modal-body"
                >
                    <slot name="body" />
                </div>

                <div class="modal-footer">
                    <slot
                        name="footer"
                        v-bind="{ close, submit }"
                    >
                        <slot
                            name="btnClose"
                            v-bind="{ close }"
                        >
                            <button
                                class="btn btn-sm btn-default"
                                type="button"
                                data-dismiss="modal"
                                :disabled="isLoading"
                                @click="close"
                            >
                                <slot name="btnCloseText">Close</slot>
                            </button>
                        </slot>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalDialog',
    props: {
        type: {
            type: String,
            default: '',
            validator(value) {
                return !value || ['danger', 'info', 'success', 'warning'].includes(value);
            },
        },
        size: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classComputedModal() {
            return this.type && `modal-${this.type}`;
        },
    },
    methods: {
        async show() {
            $(this.$refs.modal).modal('show');
            this.$emit('show');
        },
        close() {
            $(this.$refs.modal).modal('hide');
            this.$emit('close');
        },
        closed() {
            $(this.$refs.modal).modal('hidden');
            this.$emit('closed');
        },
        submit() {
            this.$emit('submit');
        },
    },
    mounted() {
        if (this.$refs && this.$refs.modal) {
            $(this.$refs.modal).on('hide.bs.modal', () => {
                this.$emit('before-hide');
            });
        }
    },
};
</script>
